export const SUGGESTIONS = "Suggestions";
export const RECENT_ORDERS = "Recent Orders";
export const ORDER_FROM_MENU = "Order From Menu";
